import React from "react"

const PageTitle = ({image, title, subtitle, tags}) => (
  <>

    <div class="page-title">
      <div class="grid-main grid-debug">
        <div></div>
        <div>

          {/* <div class="page-title-details"> */}
            {/* <div class="casestudy-hero-details"> */}
              <p class="page-title-subtitle">{subtitle}</p>
              {/* <p class="page-title-title">{title}</p> */}
              <p class="page-title-title" dangerouslySetInnerHTML={{__html: title}}></p>
            {/* </div> */}
          {/* </div> */}
          
        </div>
        <div></div>
      </div>
    </div>
    
  </>
)

export default PageTitle